<div class="row row-cols-1 row-cols-md-2 row-cols-lg-3">
  <div *ngFor="let item of items" class="col my-2">
      <app-route-card [item]="item"></app-route-card>
  </div>
</div>
